<template>
    <div class="ikz-bg-filter" v-show="dialogVisible.status" id="ikz-sys-map" style="z-index: 2001 !important;">

        <div class="ikz-sys-pic-section" v-show="dialogVisible.status">
            <div class="ikz-pic-box">
                <div class="ikz-top-menu ikz-pic-group">
                    <button type="button" :style="menu_left" class="ikz-top-menu-left" @click="menuLeft">个人资源</button>
                </div>
                <el-button type="primary" size="mini" class="ikz-pic-updata" @click="dialogVisibleUpload=true">新增资源
                    <!-- <input type="file" style="width:80px;height:28px;" id="upload_ele" multiple="false" accept="*" @input="ikzSysPicPreviewImage" class="ikz-pic-file-input" /> -->
                </el-button>
                <div class="ikz-pic-list">

                    <div class="ikz-pic-list-right">
                        <div class="ikz-pic-list-right-tips"
                            v-show="ikz_sys_pic_info.change == 'sys'&&ikz_sys_pic_info.id!=0">
                            <el-button type="text" v-for="(item,index) in ikz_sys_pic_second" :key="index"
                                class="ikz-sys-pic-tids" @mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)"
                                :style="item.color" @click="secondSelect(item.id)">{{ item.bname }}</el-button>
                        </div>
                        <div class="ikz-pic-right-image">
                            <!-- <div v-show="null_status" class="ikz-null">
                                <img class="ikz-null-img" :src="nullurl" />
                                <div class="ikz-null-title">
                                    该分类下暂无资源~
                                </div>
                            </div> -->
                            <el-table v-show="!null_status" :data="ikz_sys_pic_data" border style="width: 100%"
                                @row-click="singleElection">
                                <el-table-column label="" width="65">
                                    <template slot-scope="scope">
                                        <el-radio class="radio" v-model="templateSelection" :label="scope.$index+1">&nbsp;
                                        </el-radio>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="title" label="名称" width="150">
                                </el-table-column>
                                <el-table-column prop="file" label="资源路径" width="120">
                                    <template slot-scope="scope">
                                        <a :href="scope.row.file" target="_blank">
                                            资源路径
                                        </a>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="pic_type" label="类型" width="120">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.pic_type == 2">
                                            视频
                                        </div>
                                        <div v-else-if="scope.row.pic_type == 3">
                                            音频
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column fixed="right" label="操作" width="100">
                                    <template slot-scope="scope">
                                        <el-button @click="deleteClick(scope.row)" type="danger" size="small">删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="ikz-sys-pic-bottom">
                            <el-pagination :page-size="ikz_sys_pic_info.limit" layout="prev, pager, next"
                                :current-page="ikz_sys_pic_info.page" @current-change="handleCurrentChange"
                                :total="ikz_sys_pic_count">
                            </el-pagination>
                            <div slot="footer" class="ikz-sys-pic-btn" style="">
                                <el-button size="mini" @click="close">取 消</el-button>
                                <el-button size="mini" type="primary" @click="ikzSysPicSubmit">确 定</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisibleUpload"
          width="400px"
          :before-close="dialogVisibleUploadClose"
          :modal="false">
          <el-upload
            class="upload-demo"
            drag
            :headers='Headers'
            :action="action"
            :multiple="false"
            :on-progress="onProgress"
            :on-success="onSuccess"
            >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleUploadClose">取 消</el-button>
            <el-button type="primary" @click="dialogVisibleUploadClose">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from "axios";
    import store from '@/store'
    import setting from '@/config/setting'
    export default {
        name: 'GalleryShow',
        props: {
            infoData: [Object, String]
        },
        data() {
            return {
                action:setting.baseURL+'/storage/StorageResource/uploadFile',
                Headers:{
                    authorization:store.state.user.token,
                },
                dialogVisibleUpload:false,
                templateSelection: '',
                image_list: '',
                visible: false,
                null_status: false,
                dialogFormVisible: false, //添加分组弹窗
                form: {
                    bname: '',
                },
                img: {
                    url: '',
                },
                formLabelWidth: '120px', //弹窗宽度
                menu_left: "background:#409EFF;color:#fff;border-color:#409EFF",
                menu_right: "background:#fff;color:#353535;border-color:#DCDFE6",
                activeName: '0',
                oldactiveName: '0',
                dialogVisible: {
                    status: false
                }, //隐藏图库选择
                tabPosition: 'per',
                ikz_sys_pic_click_status: false,
                ikz_sys_pic_return: [], //选择后的图片容器
                ikz_sys_pic_data: [], //服务器图片信息接收容器
                ikz_sys_pic_count: 0, //服务器全部图片计数，用于分页显示
                ikz_sys_pic_info: {
                    'change': 'per',
                    'id': '0',
                    'limit': 5,
                    'page': 1,
                    'sid': '0',
                }, //服务器请求的参数打包
                ikz_sys_pic_receive: [], //调用接口传入的参数全局容器
                ikz_sys_pic_status: 3, //是否更新列表
                ikz_sys_pic_key: 3, //是否更新分页
                ikz_sys_pic_ajax_tid: 0, //上传图片的分类id
                ikz_sys_pic_load: '', //加载图
                picstype: [], //图库分类
                ikz_sys_pic_second: [], //二级
                show_status: 2, //初次进入
                pic_path: '', //图片服务器地址
                sys_status: false,
                upload_loading:{},
                upload_loading_status:false,

            }
        },
        watch: {
            infoData: {
                handler(newName) {
                    console.log(this.Headers)
                    this.dialogVisible = newName;
                    if (newName.status) {
                        newName.num = newName.num || -1;
                        newName.strict = newName.strict || false;
                        newName.former = newName.former || '';
                        newName.sys_status = newName.sys_status || false;
                        this.show_status = 2; //初次进入
                        this.ikz_sys_pic_receive = newName;
                        this.ikz_sys_pic_return = [];
                        this.ikz_sys_pic_status = 3;
                        this.ikz_sys_pic_key = 3;
                        this.ikzSysPicPictypelist();
                        this.ikzSysPicPictureLists();
                        this.sys_status = newName.sys_status;
                        if (!this.sys_status) {
                            this.menu_left = "background:#409EFF;color:#fff;border-color:#409EFF;border-radius: 3px;";
                        }
                    }
                },
                immediate: true,
                deep: true
            },
            activeName: {
                handler(newName, oldName) {
                    this.oldactiveName = oldName;
                },
                immediate: true,
                deep: true
            }

        },
        methods: {
            /* 上传*/
            onProgress(){
                if(!this.upload_loading_status){
                    this.upload_loading = this.$loading({
                        lock: true,
                        text: '上传中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                }else{
                    this.upload_loading_status = true;
                }
            },
            /* 上传成功*/
            onSuccess(){
                this.upload_loading.close();
                this.upload_loading_status = false;
            },
            dialogVisibleUploadClose(){
                this.ikzSysPicPictureLists();
                this.dialogVisibleUpload = false;
            },
            close() {
                this.dialogVisible.status = false
                this.templateSelection = ''
            },
            //删除操作
            deleteClick(e) {
                console.log(e);
                 this.$alert('确定删除'+e.title+'？', '删除文件', {
                  confirmButtonText: '确定',
                  showCancelButton:true,
                  callback: action => {
                      if(action == 'confirm'){
                          const loading = this.$loading({
                              lock: true
                          });
                          this.$http.post('/storage/StorageResource/delete', e).then(res => {
                              loading.close();
                              if (res.data.code === 0) {
                                  this.ikzSysPicPictureLists();
                                 this.$message.success('删除成功');
                              } else {
                                  this.$message.error(res.data.msg);
                              }
                          }).catch(e => {
                              loading.close();
                              this.$message.error(e.message);
                          });
                      }
                  }
                });
            },
            singleElection(row) {
                this.ikz_sys_pic_return[0] = row;
                // this.templateSelection = this.tableData.indexOf(row);
                // this.templateRadio = row.id;
            },
            menuLeft() {

                this.tabPosition = 2;
                this.menu_left = "background:#409EFF;color:#fff;border-color:#409EFF";
                this.menu_right = "background:#fff;color:#353535;border-color:#DCDFE6";
                this.ikz_sys_pic_info.change = 'per';
                this.activeName = '0';
                this.ikz_sys_pic_info.id = "0";
                this.ikz_sys_pic_info.limit = 18;
                this.ikz_sys_pic_info.page = 1;
                this.ikz_sys_pic_info.sid = "0";
                this.ikz_sys_pic_return = [];
                this.picstype = [];
                this.ikzSysPicPictureLists();
                this.ikzSysPicPictypelist();
            },
            menuRight() {
                this.tabPosition = 3;
                this.menu_left = "background:#fff;color:#353535;border-color:#DCDFE6";
                this.menu_right = "background:#409EFF;color:#fff;border-color:#409EFF";
                this.ikz_sys_pic_info.change = 'sys';
                this.activeName = '0';
                this.ikz_sys_pic_info.id = "0";
                this.ikz_sys_pic_info.limit = 18;
                this.ikz_sys_pic_info.page = 1;
                this.ikz_sys_pic_info.sid = "0";
                this.ikz_sys_pic_return = [];
                this.picstype = [];
                this.ikzSysPicPictureLists();
                this.ikzSysPicPictypelist();
            },


            //鼠标移入
            mouseOver(index) {
                var temp = this.ikz_sys_pic_second[index];
                temp.color = 'color:#409EFF';
                Vue.set(this.ikz_sys_pic_second, index, temp)

            },
            //鼠标移出

            mouseLeave(index) {

                var temp = this.ikz_sys_pic_second[index];
                temp.color = 'color:#303133;';
                Vue.set(this.ikz_sys_pic_second, index, temp)
            },

            /** 图库选择器封装开始 **/
            secondColor() {
                for (var j = 0; j < this.ikz_sys_pic_second.length; j++) {
                    this.ikz_sys_pic_second[j].color = '';
                }
                for (var i = 0; i < this.ikz_sys_pic_second.length; i++) {
                    if (this.ikz_sys_pic_info.sid == this.ikz_sys_pic_second[i].id) {
                        this.ikz_sys_pic_second[i].color = 'color:#409EFF';

                    }
                }

            },
            secondSelect(id) {
                this.ikz_sys_pic_info.limit = 18;
                this.ikz_sys_pic_info.page = 1;
                this.ikz_sys_pic_info.sid = id;
                this.ikz_sys_pic_return = [];
                this.ikzSysPicPictureLists();
            },
            //上传图片
            ikzSysPicPreviewImage(event) {
                let file = event.target.files[0];
                // if (/\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(event.target.value)) {
                // let MAXSIZE = 10 * 1024 * 1024;
                // let size = file.size;
                // if (size > MAXSIZE) {
                //     event.target.value = "";
                //     this.$notify.error({
                //         title: "上传图片错误",
                //         message: "上传图片不能超过10M",
                //     });
                //     return;
                // }
                const loading = this.$loading({
                    lock: true,
                    text: '上传中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.loading = true;
                let reader = new FileReader();
                let self = this;
                reader.readAsDataURL(file);
                reader.onload = function() {
                    // let base = e.target.result;
                    let fileItem = file;
                    // if (self.isCompress) {
                    //     base = self.compress(img);
                    //     fileItem = self.dataURItoBlob(base);
                    // }
                    let formdata = new window.FormData();
                    formdata.append("file", fileItem);
                    formdata.append("tid", self.ikz_sys_pic_info.id);
                    axios({
                            method: "POST",
                            url: "/storage/StorageResource/uploadFile",
                            data: formdata,
                            timeout: 1000000,
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then(() => {
                            self.ikz_sys_pic_info.page = 1;
                            self.ikzSysPicPictureLists();
                            loading.close();
                        })
                        .catch((e) => {
                            console.log(e);
                            event.target.value = "";
                            self.loading = false;
                            this.$message.error(e.message);
                            loading.close();
                        });
                };
                // } else {
                //     event.target.value = "";
                //     this.$notify.error({
                //         title: "上传图片错误",
                //         message: "请上传gif|jpg|jpeg|png|GIF|JPG|PNG格式图片",
                //     });
                // }

            },

            //显示tab
            ikzSysPicPictypelist() {
                var data = {
                    change: this.ikz_sys_pic_info.change,
                    id: this.ikz_sys_pic_info.id,
                    limit: this.ikz_sys_pic_info.limit,
                    page: this.ikz_sys_pic_info.page,
                    sid: this.ikz_sys_pic_info.sid,
                    show_status: this.show_status
                }
                const loading = this.$loading({
                    lock: true
                });
                this.$http.post('/storage/StorageResourceType/index', data).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        if (res.data.data) {
                            this.picstype = res.data.data;
                            this.picstype.unshift({
                                bname: '全部分组',
                                id: '0'
                            });
                        } else {
                            this.picstype = [];
                            this.picstype.unshift({
                                bname: '全部分组',
                                id: '0'
                            });
                        }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });

            },
            //获取图片详细信息和系统图库二级导航内容
            ikzSysPicPictureLists() {
                var that = this;
                var data = {
                    // id: this.ikz_sys_pic_info.id,
                    limit: this.ikz_sys_pic_info.limit,
                    page: this.ikz_sys_pic_info.page,
                }
                if (this.ikz_sys_pic_info.sid != 0) {
                    data.tid = this.ikz_sys_pic_info.sid
                }
                const loading = this.$loading({
                    lock: true
                });
                this.$http.post('/storage/StorageResource/index', data).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.ikz_sys_pic_count = Number(res.data.count);
                        this.ikz_sys_pic_data = res.data.data;
                        if (this.ikz_sys_pic_info.change == 'sys' && that.ikz_sys_pic_info.id != 0) {
                            this.ikz_sys_pic_second = res.data.second_info;

                            this.ikz_sys_pic_second.unshift({
                                bname: '全部',
                                id: '0',
                            });
                            this.secondColor();

                        }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
            //点击下一页
            handleCurrentChange(e) {
                this.ikz_sys_pic_info.page = Number(e);
                this.ikzSysPicPictureLists();
            },

            //提交
            ikzSysPicSubmit() {
                //判断是否选择图片
                if (this.ikz_sys_pic_return.length == 0) {
                    this.$message('请选择图片后再提交');
                    return false;
                } else {
                    var res_info_data = {};
                    //判断是否为无限张
                    if (this.ikz_sys_pic_receive.num == '-1') {
                        res_info_data = {
                            former: this.ikz_sys_pic_receive.former,
                            data: this.ikz_sys_pic_return
                        }
                        this.$emit('picReturn', res_info_data);
                        //						ikz_sys_pic_receive.success(res_info_data);
                        this.ikz_sys_pic_return = [];
                        this.ikz_sys_pic_status = 3;
                        this.ikz_sys_pic_key = 3;
                    } else if (this.ikz_sys_pic_receive.num > '0') {
                        //判断是否严格限制数量
                        if (this.ikz_sys_pic_receive.strict) {
                            if (this.ikz_sys_pic_receive.num == this.ikz_sys_pic_return.length) {
                                res_info_data = {
                                    former: this.ikz_sys_pic_receive.former,
                                    data: this.ikz_sys_pic_return
                                }
                                this.$emit('picReturn', res_info_data);
                                this.ikz_sys_pic_return = [];
                                this.ikz_sys_pic_status = 3;
                                this.ikz_sys_pic_key = 3;
                                this.templateSelection = '';
                            } else {
                                this.$message('请选择' + this.ikz_sys_pic_receive.num + '图片后在提交！');
                                return false;
                            }
                        } else {
                            res_info_data = {
                                former: this.ikz_sys_pic_receive.former,
                                data: this.ikz_sys_pic_return
                            }
                            this.$emit('picReturn', res_info_data);
                            this.ikz_sys_pic_return = [];
                            this.ikz_sys_pic_status = 3;
                            this.ikz_sys_pic_key = 3;
                            this.templateSelection = '';
                        }
                    }
                    this.dialogVisible.status = false;
                }
            },


            /** 图库选择器封装结束 **/


            upload: function() {
                let files = this.$refs.avatarInput.files
                let fileData = {}
                if (files instanceof Array) {
                    fileData = files[0]
                } else {
                    fileData = this.file
                }
                let data = new FormData()
                data.append('multfile', fileData)
                data.append('operaType', this.uploadType)
                this.$store.dispatch('UPLOAD_HEAD', data)
                    .then(res => {
                        this.file = '';
                        let data = res.data.data;
                        this.$emit("upload", data);
                        this.$message({
                            type: "success",
                            message: "上传成功！"
                        })
                    }).catch(err => {
                        if (err.data.msg) {
                            this.$message({
                                type: "error",
                                message: err.data.msg
                            })
                        } else {
                            this.$message({
                                type: "error",
                                message: "上传失败"
                            })
                        }
                    })
            }
        },
        mounted() {

        },
        computed: {}
    }
</script>
<style scoped>
    .ikz-add-type {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 1010;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ikz-add-box {
        width: 400px;
        height: 210px;
        background: #fff;
        border-radius: 5px;
    }

    .ikz-add-title {
        text-align: center;
        line-height: 50px;
    }

    .ikz-add-form {
        margin-top: 20px;
    }

    .ikz-add-footer {
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-content: center;
    }

    .ikz-bg-filter {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 9999;
    }

    .ikz-sys-pic-section {
        width: 800px;
        height: 600px;
        position: fixed;
        margin: auto;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        z-index: 300;
        background-color: #fff;
        border: 1px solid #ddd;
        border-radius: 2px;
    }

    .ikz-top-menu {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10px;
    }

    .ikz-top-menu-left {
        /*#409EFF*/
        border-left: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        border-top: 1px solid #DCDFE6;
        border-right: 0px;
        background: #fff;
        padding: 7px;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }

    .ikz-top-menu-right {
        border-right: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        border-top: 1px solid #DCDFE6;
        border-left: 0px;
        background: #fff;
        padding: 7px;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
    }

    .ikz-pic-right-image {
        width: 86%;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        margin: 15px auto 0px;
    }

    .ikz-pic-list-right-tips {
        margin: 0px 50px;
    }

    .ikz-pic-list-left-tabs {
        height: 100%;
    }

    .ikz-pic-list-right {
        width: 86%;
        position: relative;
        height: 546px;
    }

    .ikz-pic-list-left {
        height: 546px;
        width: 18%
    }

    .ikz-pic-list {
        display: flex;
    }

    .ikz-pic-file-input {
        opacity: 0;
        position: absolute;
        right: 20px;
        top: 0px;
        z-index: 99;
    }

    .ikz-pic-updata {
        position: absolute;
        right: 20px;
        top: 0px;
    }

    .ikz-pic-group {
        /*margin-top: 10px;*/
        padding-bottom: 10px;
        display: flex;
        justify-content: center;
        border-bottom: 1px solid #eee;
    }

    .ikz-pic-box {
        height: 442px;
        position: relative;
    }

    .ikz-sys-pic-page {
        margin: 0;
        height: 100%;
        text-align: center;
    }

    .ikz-sys-pic-list {
        width: 20%;
    }

    .ikz-sys-pic-tab {
        text-align: center;
    }

    .ikz-sys-pic-pics {
        display: flex;
        flex-wrap: wrap;
        font-size: 15px;
        margin: 25px 4%;
    }

    .ikz-sys-pic-picsbod {
        width: 70px;
        height: 70px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #ddd;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ikz-sys-pic-picssdiv {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        font-size: 50px;
        text-align: center;
        color: rgb(255, 255, 255);
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
    }

    .ikz-sys-pic-picsselt {
        z-index: 99999;
    }

    .ikz-sys-pic-picspic {
        width: 68px;
        max-height: 68px;
    }

    .ikz-sys-pic-pages {
        text-align: center;
    }

    .ikz-sys-pic-alert {
        position: fixed;
        top: 30%;
        left: 0px;
        right: 0px;
        margin: auto;
        z-index: 999;
        background-color: #f7f7f7;
        width: 500px;
        height: 180px;
        padding-top: 40px;
        border-radius: 5px;
        text-align: center;
    }

    .ikz-sys-pic-dl {
        width: 100%;
        height: 400px;
        overflow-y: scroll;
    }

    .ikz-sys-pic-bottom {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 10px;
    }

    .ikz-sys-pic-btn {
        width: 100%;
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }

    .ikz-sys-pic-prompt {
        display: block;
        text-align: center;
        width: 100%;
    }

    .ikz-sys-pic-tids {
        margin-bottom: 0px;
        margin-top: 8px;
        padding: 0px;
        font-size: 14px;
        line-height: 1;
        font-weight: 700;
        text-decoration: none;
        -webkit-transition: color .2s cubic-bezier(.645, .045, .355, 1);
        transition: color .2s cubic-bezier(.645, .045, .355, 1);
        color: #303133;
        margin-left: 8px;
    }

    .ikz-null {
        width: 86%;
        height: 100px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }

    .ikz-null-img {
        width: 50px;
        height: 50px;
    }

    .ikz-null-title {
        width: 100%;
        text-align: center;
        color: #777777;
        font-size: 14px;
        margin-top: 10px;
    }
</style>
